export default __webpack_public_path__ + "static/media/ralph lourn.7e54bad4.svg";